import React from 'react';
import {Row, Col, CardPanel, Button} from 'react-materialize';

import icon_trophy from '../../images/icon_trophy.png';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';


export const Finish =(props)=>{
    return(
        <div>
            <br />
            <Row>
                <Col s={12} m={2} offset={"m5"} >

                    <div align="center">
                        <img src={icon_trophy} className={"center"} alt={"trophy"} width={"100"} height={"100"}/>
                        <br/>
                    </div>

                    <h5 align="center"><FormattedMessage id={"score"} defaultMessage={"Score final:"}/></h5>
                    <CardPanel className="blue darken-1 black-text" title="Score" align={"center"}>
                        <span className="header center white-text text-lighten-2">{props.score}</span>
                    </CardPanel>
                </Col>
            </Row>
            <Button className={"btn"} waves='light' onClick={()=>props.handleState('running')}><FormattedMessage id={"try"} defaultMessage={"Tente novamente"}/></Button>
        </div>
    )
};

export default Finish;